export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/default-rzxx-ad0de0a5dddd0dd0ac4703383abc1ab9.png";